import _defaults from 'lodash/defaults';

import { Company } from './Company';
import { CurrencyType } from './Money';
import { PaginationOptions } from './Pagination'
import { Department } from './Department'

enum EmpType {
    None = 0,
    Employee = 1,
    Manager = 2,
    Executive = 3,
    Accountant = 4,
    Guest = 5
}

class DelegateEmp {
    public ID: string;
    public Name: string;
    public Email: string;

    public constructor (params: Partial<DelegateEmp>) {
        _defaults(this, params);
    }
}

const defaultEmployee: Partial<Employee> = {
    CurrencyType: new CurrencyType(),
    FirstName: '',
    LastName: '',
    FullName: '',
    Email: '',
    EmpType: EmpType.None,
    EmployeeID: '',
    Language: null,
    UID: ''
}

class Employee {
    public PK: number
    public ID: string;
    public CurrencyType: CurrencyType;
    public FirstName: string;
    public LastName: string;
    public FullName: string;
    public Email: string;
    public EmpType: EmpType;
    public EmployeeID: string;
    public Language: number;
    public Company: Company;
    public UID: string
    public CreateDate: string;
    public Department: Department;

    public constructor (employee?: Partial<Employee>) {
        _defaults(this, employee);
    }
}

const defaultEmployeeOptions: Partial<GetEmployeeOptions> = {
    search: '',
    pagination: {
        page: 1,
        pageSize: 100,
        sort: {field:"Usr_FName", sort:"asc"}
    }
}

class GetEmployeeOptions {
    public search: string;
    public pagination: PaginationOptions;

    public constructor (employeeOptions?: Partial<GetEmployeeOptions>) {
        _defaults(this, employeeOptions, defaultEmployeeOptions);
    }
}

export {
    DelegateEmp,
    EmpType,
    Employee,
    GetEmployeeOptions,
    defaultEmployee
};
